module.exports = __webpack_public_path__ + "img/9PointMotorFunction_Icon_200x200_Black.8651057b.png";